export default {
    navigationBarTitleText: '消息',
};
